import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import RequestServies from "../../../services/RequestServices";
import ApproveOrRejectRequisitionModal from "./ApproveOrRejectRequisitionModal";
import Swal from 'sweetalert2';

const PendingTransferApproval = ({ onSuccess }) => {
  const user = JSON.parse(localStorage.getItem("userDetails"));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || "";

  const [selectedStore, setSelectedStore] = useState(defaultStore);
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [data, setData] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [requisition, setRequisiton] = useState();
  const [selectedRequisition, setSelectedRequisiton] = useState();
  const [run, setRun] = useState(0);

  const activePag = useRef(0);

  useEffect(() => {
    if (selectedStore) {
      const status = "submit";
      RequestServies.getTrasfer(selectedStore, status)
        .then((res) => {
          setRequisiton(res?.data?.data);
          setSelectedRequisiton(res?.data?.data[0]._id);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [selectedStore]);

  useEffect(() => {
    if (selectedStore && selectedRequisition) {  // Ensure both are set
      const status = "pending";
      RequestServies.getTransferAllItem(selectedStore, status, selectedRequisition)
        .then((res) => {
          setData(res?.data?.data);
        })
        .catch((error) => {
          // Log the error response for debugging
          console.error('Error Response:', error.response);
  
          // Extract the message from the API response or default to a generic error message
          const errorMessage = error.response?.data?.error?.message || "An unexpected error occurred";
  
          // Display the error message in a SweetAlert
          Swal.fire({
            title: 'Error!',
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        });
    }
  }, [selectedStore, selectedRequisition, run]);

  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
  };

  const handleRequsitionChange = (e) => {
    setSelectedRequisiton(e.target.value);
  };

  const pagination = Math.ceil(data.length / 5); // Change to 5, for example
  const onClick = (i) => {
    activePag.current = i;
  };

  const handleModel = (e, item) => {
    setSelectedItem(item);  
    setGridInsideModal(true);
  }

  return (
    <>
     <ApproveOrRejectRequisitionModal
        show={gridInsideModal}
        item={selectedItem}
        handleClose={() => setGridInsideModal(false)}
        onSuccess={() => setRun(prev => prev + 1)}
      />
     
      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fas fa-filter me-2"></i>Filter
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                  onClick={() => setOpen(!open)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-6 col-xxl-6">
                      <select
                        className="form-select mb-xl-0 mb-3"
                        value={selectedStore}
                        onChange={handleStoreChange}
                      >
                        {availableStores.map((store) => (
                          <option key={store._id} value={store._id}>
                            {store.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-xl-6 col-xxl-6">
                      <select
                        className="form-select mb-xl-0 mb-3"
                        value={selectedRequisition}
                        onChange={handleRequsitionChange}
                      >
                        {requisition?.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.transferNo}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
          <div className="filter cm-content-box box-primary mt-1">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fa fa-list me-2" aria-hidden="true"></i>Pending
                Approval{" "}
                <span className="badge bg-orange ms-2">{data.length}</span>
              </div>
              <div className="tools">
                <Link
                  to="#"
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                  onClick={() => setOpen2(!open2)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <div
                      id="content_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                       <div style={{
                        overflowX: 'auto',
                        overflowY: 'auto',
                        maxHeight: '400px',
                        whiteSpace: 'nowrap',
                        position: 'relative',   // ✅ ADD THIS
                        zIndex: 0               // ✅ ADD THIS
                      }}>
                      <table
                        className="table table-bordered table-responsive-lg table-striped table-condensed flip-content"
                        id="active-users-data"
                      >
                        <thead
                            style={{
                              position: "sticky",
                              top: 0,
                              backgroundColor: "#fff",
                              zIndex: 1,              // ✅ LOWER than sidebar
                            }}
                          >
                          <tr>
                            <th>S.No</th>
                            <th>Transfer No</th>
                            <th>Part No</th>
                            <th>Description</th>
                            <th>AuthQty</th>
                            <th>currentStock</th>
                            <th>Transfer</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.length > 0 ? (
                            data
                              .slice(
                                activePag.current * 5,
                                (activePag.current + 1) * 5
                              )
                              .map((item, index) => (
                                <tr key={index}>
                                  <td>
                                    {activePag.current * 5 + index + 1}
                                  </td>
                                  <td>{item?.transfer?.transferNo}</td>
                                  <td>{item?.inventory?.masterItem?.partNo}</td>
                                  <td className="scrollable-description">{item?.inventory?.masterItem?.description}</td>
                                  <td>{item?.inventory?.qtyAuth}</td>
                                  <td>
                                    {item?.inventory?.currentStock}
                                  </td>
                                  <td>{item?.transferQty}</td>
                                  <td className="text-center">
                                    <button className="btn btn-primary btn-xs sharp" onClick={(e) => { handleModel(e, item) }}>
                                      <i className="fa fa-pencil"></i>
                                    </button>
                                    <button className="btn btn-danger btn-xs sharp">
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  </td>
                                </tr>
                              ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center">
                                No Active items Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      </div>
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                        <div className="dataTables_info">
                          Showing {activePag.current * 5 + 1} to{" "}
                          {Math.min(
                            data.length,
                            (activePag.current + 1) * 5
                          )}{" "}
                          of {data.length} entries
                        </div>
                        <div className="dataTables_paginate paging_simple_numbers">
                          <Link
                            className="paginate_button previous"
                            to="#"
                            onClick={() =>
                              activePag.current > 0 &&
                              onClick(activePag.current - 1)
                            }
                          >
                            <i
                              className="fa fa-angle-double-left"
                              aria-hidden="true"
                            ></i>
                          </Link>
                          <span>
                            {Array.from({ length: pagination }, (_, i) => (
                              <Link
                                key={i}
                                to="#"
                                className={`paginate_button ${
                                  activePag.current === i ? "current" : ""
                                }`}
                                onClick={() => onClick(i)}
                              >
                                {i + 1}
                              </Link>
                            ))}
                          </span>
                          <Link
                            className="paginate_button next"
                            to="#"
                            onClick={() =>
                              activePag.current < pagination - 1 &&
                              onClick(activePag.current + 1)
                            }
                          >
                            <i
                              className="fa fa-angle-double-right"
                              aria-hidden="true"
                            ></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingTransferApproval;
